/**
 * `<app-panel>` — Three-slot layout component using CSS grid.
 *
 * Header and footer fit their content; main fills remaining space.
 *
 * @slot header - Top section.
 * @slot - Main content (default slot).
 * @slot footer - Bottom section.
 */

import { css, html, LitElement, type TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { base } from "../../design-system/index.ts";
import "../dui/scroll-area/dui-scroll-area.ts";

const hostStyles = css`
  :host {
    display: block;
    height: 100%;
  }

  .Panel {
    display: grid;
    grid-template-rows: min-content 1fr min-content;
    height: 100%;
  }
`;

@customElement("app-panel")
export class AppPanelElement extends LitElement {
  static override styles = [base, hostStyles];

  override render(): TemplateResult {
    return html`
      <div class="Panel">
        <slot name="header"></slot>
        <dui-scroll-area><slot></slot></dui-scroll-area>
        <slot name="footer"></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "app-panel": AppPanelElement;
  }
}
